import { render, staticRenderFns } from "./DocumentDetailList32.vue?vue&type=template&id=45e5dd94&scoped=true"
import script from "./DocumentDetailList32.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList32.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailList32.vue?vue&type=style&index=0&id=45e5dd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5dd94",
  null
  
)

export default component.exports